import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAttributes, useProductTypes } from '@/features/dictionary';

import { buildRuleFields, kindOfField, type RuleFieldDef } from '../schemas/rule-fields';

/** The fields a rule can test, built from the dictionary with translated product-field labels. */
export function useRuleFields() {
  const { t } = useTranslation(['productRules', 'products']);
  const attributes = useAttributes();
  const productTypes = useProductTypes();

  const fields = useMemo<RuleFieldDef[]>(
    () =>
      buildRuleFields({
        productTypes: productTypes.data ?? [],
        attributes: attributes.data ?? [],
        productFieldLabel: (field) => t(`productRules:rules.fields.${field}`),
        fulfillmentModeLabel: (mode) => t(`products:fulfillmentMode.${mode}`),
      }),
    [attributes.data, productTypes.data, t],
  );

  const kindOf = useCallback((field: string) => kindOfField(field, fields), [fields]);

  return {
    fields,
    kindOf,
    isLoading: attributes.isPending || productTypes.isPending,
  };
}
